import { Button } from "@fp/ui/components/base/buttons/button";
import { PageContentContainer } from "@fp/ui/components/base/page-layout/page-layout";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin-layout";

export const HomePageContent = () => {
  const router = useRouter();
  return (
    <PageContentContainer className="pt-0 overflow-x-hidden bg-white">
      <div className="overflow-y-auto min-h-30 mb-20">
        <div className="min-h-30 w-[120%] bg-brand-600 rounded-b-[50%] absolute left-1/2 translate-x-[-50%]">
          <div className="flex flex-col items-center justify-center"></div>
        </div>
      </div>
      <div className="size-[100px] rounded-full bg-white flex items-center justify-center border-white border-6 mt-[30px] absolute top-0 translate-y-[50%] left-1/2 translate-x-[-50%]">
        <img src="/Logo-green-bg.svg" alt="Hero Icon" />
      </div>
      <div className="mb-16">
        <h1 className="text-4xl font-bold text-brand-600 text-center mb-5">
          FieldPay
        </h1>
        <p className="text-xl text-center">
          With FieldPay you can activate your team with instant pay
          opportunities called “Opps”.
        </p>
      </div>
      <div>
        <img
          src="/Fieldpay-greyhound.svg"
          alt="Fieldpay Greyhound"
          className="mx-auto"
        />
      </div>
      <div className="flex items-end flex-grow">
        <Button
          type="button-primary"
          className="w-full h-16"
          onClick={() => {
            router.navigate({ to: "/opps/templates" });
          }}
        >
          Continue
        </Button>
      </div>
    </PageContentContainer>
  );
};

export const Route = createFileRoute("/home")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AdminLayout>
      <HomePageContent />
    </AdminLayout>
  );
}
